import { api } from '@api/api2';
import { CreateTicketPayload, GetFieldsPayload, UpdateTicketPayload } from './types';

const getCustomFields = (payload: GetFieldsPayload) =>
  api.v1('get', 'tck/bms/tickets/schema/form', payload);

const createTicket = (payload: CreateTicketPayload) =>
  api.v1('post', 'tck/bms/tickets/schema/create', payload, {
    headers: { 'Content-Type': 'application/json' },
  });

const updateTicket = (payload: UpdateTicketPayload) =>
  api.v1('post', 'tck/bms/tickets/schema/update', payload, {
    headers: { 'Content-Type': 'application/json' },
  });

const switchToCustomFields = () =>
  api.v1('post', 'tck/bms/metric/switch-to-custom-fields');

export const sdui = {
  getCustomFields,
  createTicket,
  updateTicket,
  switchToCustomFields,
};
